module.exports = __webpack_public_path__ + "img/person_4.c3fd870f.jpg";